import { fromClass, fromClassArray } from "fw-model";

export class GaugeStat {
    Time: string;
    Count: number;
    Total: number;
    Last: number;
    Min: number;
    Max: number;
    Average: number;
}

export class GaugeStatSummary {
    Name: string;
    StartTime: string;
    EndTime: string;
    @fromClassArray(GaugeStat) Stats: GaugeStat[] = [];
    Count: number;
    Total: number;
    Last: number;
    Min: number;
    Max: number;
    Average: number;
}

export class TimingStat {
    Time: string;
    Count: number;
    TotalDuration: number;
    MinDuration: number;
    MaxDuration: number;
    AverageDuration: number;
}

export class TimingStatSummary {
    Name: string;
    StartTime: string;
    EndTime: string;
    @fromClassArray(TimingStat) Stats: TimingStat[] = [];
    Count: number;
    MinDuration: number;
    MaxDuration: number;
    TotalDuration: number;
    AverageDuration: number;
}

export class CounterStat {
    Time: string;
    Count: number;
}

export class CounterStatSummary {
    Name: string;
    StartTime: string;
    EndTime: string;
    @fromClassArray(CounterStat) Stats: CounterStat[] = [];
    Count: number;
}

export class QueueStatSummary {
    @fromClass Count: GaugeStatSummary;
    @fromClass Working: GaugeStatSummary;
    @fromClass Deadletter: GaugeStatSummary;
    @fromClass Enqueued: CounterStatSummary;
    @fromClass QueueTime: TimingStatSummary;
    @fromClass Dequeued: CounterStatSummary;
    @fromClass Completed: CounterStatSummary;
    @fromClass Abandoned: CounterStatSummary;
    @fromClass ProcessTime: TimingStatSummary;
}
